export default __webpack_public_path__ + "d675ab9.png";